<template>
  <div id="content">
    <header class="m15 container">
      <div class="integralBreadcrumb">
        <div class="integralBreadcrumb-item"
             @click="routerHandle('onlineTraining')">首页</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item"
             @click="routerHandle('teacherList')">讲师列表</div>
        <div class="el-icon-arrow-right jt"></div>
        <div class="integralBreadcrumb-item">讲师详情</div>
      </div>
    </header>
    <!-- 讲师详情 -->
    <!-- 图片介绍 -->
    <div class="introduce-img">
      <div class="container">
        <div class="teacher-img">
          <img :src="dataForm.teacherImg?dataForm.teacherImg:imgUrl" />
        </div>
        <div class="teacher-info">
          <h3>{{dataForm.teachername}}</h3>
          <p class="info-first">{{dataForm.education}}</p>
          <p class="info-sec">{{dataForm.career}}
          </p>
        </div>
      </div>
    </div>
    <!-- 列表介绍 -->
    <div class="course-wrap">
      <div class="container">
        <div class="course-classify">
          <h4><span>主讲课程</span></h4>
        </div>
        <div class="main-course-list">
          <dl v-for="(item, index) in courseList"
              :key="item.id"
              :class="index%4==0? 'course-margin' :''">
            <dt @click="handleCourseDetail(item.id)">
              <img :src="item.url?item.url:img" />
            </dt>
            <dd @click="handleCourseDetail(item.id)">{{item.courseName}}</dd>
          </dl>
        </div>
      </div>
      <!-- 分页 -->
      <div class="doclist-pagination"
           v-if="courseList === [] || courseList.length !== 0">
        <div class="doclist-lastpage"
             @click="jumpLastPage">上一页</div>
        <div class="doclist-omit">{{lastOmit}}</div>
        <ul>
          <li :class="item === currentPage?'pageactive':''"
              v-for="(item, index) in pageList"
              :key="index"
              @click="getInfo(item)">{{item}}</li>
        </ul>
        <div class="doclist-omit">{{nextOmit}}</div>
        <div class="doclist-nextpage"
             @click="jumpNextPage">下一页</div>
        <div class="doclist-pagejump">
          共{{totalPage}}页，到第
          <input type="text"
                 v-model.number="jumpTargetPage" />页
        </div>
        <div class="doclist-jump"
             @click="jumpFarPage">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      courseList: [],
      pageIndex: 1,
      pageSize: 8,
      totalPage: 0,
      totalData: 0,
      imgUrl: '../../../../assets/img/avatar-boy.gif',
      img: '../../../../assets/img/占位图_en.png',
      dataForm: {
        teachername: '',
        teacherImg: '',
        education: '',
        career: ''
      },
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1
    }
  },
  mounted () {
    this.getInfo()
  },
  methods: {
    routerHandle (routerName) {
      if (routerName === 'onlineTraining') {
        this.$router.push({ name: 'onlineTraining' })
      } else if (routerName === 'teacherList') {
        this.$router.push({ name: 'teacherList' })
      }
    },
    // 获取详细信息
    getInfo (page = this.currentPage) {
      this.$http.post(`/front/train/trainTeacher/teacherInfo`, {
        'page': page,
        'limit': this.pageSize,
        'id': this.$route.query.id
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.dataForm.teachername = res.data.teacher.name
          this.dataForm.teacherImg = res.data.teacher.url
          this.dataForm.education = res.data.teacher.education
          this.dataForm.career = res.data.teacher.career
          this.courseList = res.data.course.data
          this.totalData = res.data.course.count
          // 分页
          this.totalPage = Math.ceil(res.data.course.count / 8)
          this.changePageTo(page)
        }
      })
      this.jumpTargetPage = 1
    },
    // 跳转课程详细
    handleCourseDetail (id) {
      // 浏览次数加一
      this.$http.post(`/front/train/trainQuestionAnswer/plusViewCount`, {
        type: 2, // type --1:新闻/2：课程/3：图书/4：问答
        id: id
      })
      this.$router.push({ name: 'courseDetail', query: { id: id } })
    },
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.getInfo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.getInfo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [
            this.totalPage - 4,
            this.totalPage - 3,
            this.totalPage - 2,
            this.totalPage - 1,
            this.totalPage
          ]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
    },
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (
            this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4
          ) {
            var newPageList3 = []
            for (
              let index = this.jumpTargetPage - 2;
              index < this.jumpTargetPage + 3;
              index++
            ) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [
              this.totalPage - 4,
              this.totalPage - 3,
              this.totalPage - 2,
              this.totalPage - 1,
              this.totalPage
            ]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getInfo()
        window.scrollTo(0, 0)
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getInfo()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getInfo()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped>
.all-left-wrap {
  width: 870px;
  min-height: 1531px;
  float: left;
  background: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.introduce-img {
  width: 100%;
  height: 220px;
  background: #5c79a3;
  padding-top: 30px;
}
.teacher-img {
  width: 110px;
  height: 110px;
  background: #fff;
  padding: 5px;
  border-radius: 50%;
  float: left;
}
.teacher-img img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
.teacher-info {
  float: left;
  width: 800px;
  height: 180px;
  margin-left: 30px;
}
.teacher-info h3 {
  font-size: 20px;
  color: #fff;
  font-weight: normal;
}
.info-first {
  color: #fff;
  margin: 15px 0;
}
.info-sec {
  color: #fff;
}
.course-classify {
  width: 100%;
  height: 70px;
  text-align: left;
  padding: 20px 0px;
}
.course-classify h4 {
  font-weight: normal;
  color: #333;
}
.course-classify span {
  border-left: 5px solid #333;
  color: #333;
  font-size: 16px;
  display: inline-block;
  line-height: 18px;
  padding-left: 10px;
}
.main-course {
  width: 100%;
  height: 800px;
  background: pink;
}
.main-course-list {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.main-course-list dl {
  width: 278px;
  margin-left: 22px;
  margin-bottom: 40px;
  height: 240px;
  background: #fff;
  float: left;
  margin-bottom: 30px;
  border: 1px solid #ccc;
}
.main-course-list dl dt {
  width: 100%;
  height: 190px;
  cursor: pointer;
}
.main-course-list dl dt img {
  width: 100%;
  height: 190px;
}
.main-course-list dl dd {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 50px;
  width: 55%;
  line-height: 50px;
  padding-left: 10px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
}
.main-course-list dl dd:hover {
  color: #1d65a8;
}
.main-course-list dl.course-margin {
  margin-left: 0;
}
.course-wrap {
  width: 100%;
  height: 700px;
  background: #fff;
}
</style>
